import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f9bd8b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loadingSpinner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "mdi mdi-spin mdi-loading",
  style: {"fontSize":"8rem"}
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toast = _resolveComponent("Toast")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_VerticalNavbar = _resolveComponent("VerticalNavbar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Toast, {
      position: "bottom-right",
      group: "br"
    }),
    _createVNode(_component_ConfirmDialog),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.route.name && !_ctx.isRouteWithoutLogin() && !_ctx.loading && !_ctx.route.fullPath.includes('system-administration'))
      ? (_openBlock(), _createBlock(_component_VerticalNavbar, {
          key: 1,
          links: _ctx.navbarLinks,
          hideNavbar: !!_ctx.apiKeyParam,
          onIsUploadDialogShown: _ctx.isUploadDialogShown,
          onOnCollapseSidebar: _cache[0] || (_cache[0] = ($event: any) => (_ctx.opened = !_ctx.opened)),
          onUserLoggedOut: _cache[1] || (_cache[1] = ($event: any) => (_ctx.opened = false))
        }, null, 8, ["links", "hideNavbar", "onIsUploadDialogShown"]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass({'view-open': _ctx.opened, 'view': !_ctx.isRouteWithoutLogin() && !_ctx.route.fullPath.includes('system-administration') && !_ctx.apiKeyParam, 'login-background-image': _ctx.isRouteWithoutLogin() && !_ctx.route.fullPath.includes('system-administration')})
        }, [
          _createVNode(_component_router_view, { isUploadShown: _ctx.isUploadShown }, null, 8, ["isUploadShown"])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}